
import React from "react";

const UseCasesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Use <span className="text-[#8932c8]">Cases</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Discover how Spharaka XDR can address your specific security challenges.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-xl font-semibold mb-2">Ransomware Protection</h3>
            <p className="text-gray-600">
              Prevent ransomware attacks with proactive detection and automated containment.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-xl font-semibold mb-2">Insider Threat Detection</h3>
            <p className="text-gray-600">
              Identify and stop malicious insiders with behavioral analytics and anomaly detection.
            </p>
          </div>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-slate-200">
            <h3 className="text-xl font-semibold mb-2">Cloud Security</h3>
            <p className="text-gray-600">
              Secure your cloud workloads and applications with comprehensive visibility and control.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
